import React from 'react';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import { useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import cn from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import s from './UpsellWrapper.scss';
const UpsellWrapper = ({ upsellType , children , unit , className  })=>{
    const { t  } = useTranslation();
    const adsUpsell = useFlag('ads_upsell');
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], className)
    }, children, adsUpsell && /*#__PURE__*/ React.createElement(TextButton, {
        className: s['button'],
        size: "small",
        variant: "main",
        href: URLS.CORE_MEMBERSHIP,
        biData: BiData({
            evid: 2,
            click_info: `ads_core_upsell_${unit}`,
            sectionname: BiContextProvidedValue,
            itemid: BiContextProvidedValue,
            typeid: BiContextProvidedValue,
            widgetname: BiContextProvidedValue
        })
    }, t(`ads.upsell.${upsellType}`)));
};
UpsellWrapper.displayName = 'UpsellWrapper';
export default UpsellWrapper;
